

import React, { useContext, useState } from 'react'
import { GlobalContext } from '../GlobalContext'
import CloudformationOutputs from '../CloudformationOutputs.json'
import Modal from '../ui-elements/Modal'
import YellowAlert from '../ui-elements/YellowAlert'

type Props = {
    thisChecklistPeriod: ObjectStringKeyAnyValue
}

function FormatCheckPeriodInProgress({
    thisChecklistPeriod
}: Props) {

    const {
        tableData
    } = useContext(GlobalContext)

    const inProgress = thisChecklistPeriod && thisChecklistPeriod.InProgress === 'True' ? true : false

    if (inProgress || !thisChecklistPeriod) {
        return null
    }


    return <YellowAlert fullwidth={true} alignment={`left`}>⏰ Check period ended. Checklist is no longer editable</YellowAlert>
}

export default FormatCheckPeriodInProgress